import { Directive } from '@angular/core';

/**
 * The directives defined in this file are used by the ng-content select input
 * to differentiate the various slots to place content in a field.
 *
 * Currently they are all directives because there is no further functionality
 * than to denote a spot where they live in the field.
 *
 * However by giving them a formal directive class we remove some of the "magic knowledge"
 * by giving them a proper registered selector.
 *
 */

@Directive({
  selector: 'pg-field-subscript, grit-field-subscript',
})
export class PgFieldSubscriptDirective {
  constructor() {}
}

@Directive({
  selector: 'pg-field-superscript, grit-field-superscript',
})
export class PgFieldSuperscriptDirective {
  constructor() {}
}

@Directive({
  selector: 'pg-field-prefix, grit-field-prefix',
})
export class PgFieldPrefixDirective {
  constructor() {}
}

@Directive({
  selector: 'pg-field-suffix, grit-field-suffix',
})
export class PgFieldSuffixDirective {
  constructor() {}
}

@Directive({
  selector: 'pg-field-top-border-gap, grit-field-top-border-gap',
})
export class PgFieldTopBorderGapDirective {
  constructor() {}
}

@Directive({
  selector: 'pg-field-bottom-border-gap, grit-field-bottom-border-gap',
})
export class PgFieldBottomBorderGapDirective {
  constructor() {}
}
